import ArticlePreview from "@/components/ArticlePreview";
import { useExportablesContext } from "@/components/AIComponents/ExportablesModal/ExportablesContextProvider/useExportablesContext";
import {
  articlePreviewWrapperCss,
  contentWrapperCss,
  mediaWrapperCss,
  titleCss,
  titleWrapperCss,
} from "./ExportablesArticlePreview.styles";

const ExportablesArticlePreview = () => {
  const { content, contentMetadata, currentLevel } = useExportablesContext();

  return (
    <div css={articlePreviewWrapperCss}>
      <ArticlePreview
        content={content}
        currentLevel={currentLevel}
        contentMetadata={contentMetadata}
        styleOverrides={{
          title: titleCss,
          titleWrapper: titleWrapperCss,
          mediaWrapper: mediaWrapperCss,
          contentWrapper: contentWrapperCss,
        }}
      />
    </div>
  );
};

export default ExportablesArticlePreview;
